// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewBatchId } from './BrewBatch';
import { brewSampleId } from './BrewSample';
import { testTemplateRevisionId } from './TestTemplateRevision';
import { testStatusEnum } from './TestStatusEnum';
import { externalTestPartnerId } from './ExternalTestPartner';
import { operatorId } from './Operator';
import { testOverallResultEnum } from './TestOverallResultEnum';
import { testSessionId } from './TestSession';
import { foodRecipeId } from './FoodRecipe';
import { foodBenchmarkId } from './FoodBenchmark';
import { foodTestRoundId } from './FoodTestRound';
import { fermentationSampleId } from './FermentationSample';
import { testInstanceCreationSourceEnum } from './TestInstanceCreationSourceEnum';
import { z } from 'zod';
export const testInstanceId = (z.number());
export const testInstance = z.object({
    id: testInstanceId,
    brew_batch_id: brewBatchId.nullable(),
    brew_sample_id: brewSampleId.nullable(),
    test_template_id: testTemplateRevisionId.nullable(),
    name: z.string(),
    test_number: z.string().nullable(),
    status: testStatusEnum,
    is_external: z.boolean(),
    external_test_partner_id: externalTestPartnerId.nullable(),
    assigned_operator_id: operatorId.nullable(),
    reviewed_by_operator_id: operatorId.nullable(),
    planned_start_at: z.date().nullable(),
    actual_start_at: z.date().nullable(),
    planned_completion_at: z.date().nullable(),
    actual_completion_at: z.date().nullable(),
    reviewed_at: z.date().nullable(),
    overall_result: testOverallResultEnum.nullable(),
    result_summary: z.string().nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    test_session_id: testSessionId.nullable(),
    food_recipe_id: foodRecipeId.nullable(),
    food_project_benchmark_id: foodBenchmarkId.nullable(),
    food_test_round_id: foodTestRoundId.nullable(),
    fermentation_sample_id: fermentationSampleId.nullable(),
    lab_sample_code: z.string().nullable(),
    external_sample_reference: z.string().nullable(),
    external_material_ref: z.string().nullable(),
    creation_source: testInstanceCreationSourceEnum,
    requested_at: z.date().nullable(),
    requested_by: operatorId.nullable(),
    request_withdrawn_at: z.date().nullable(),
    request_withdrawn_by: operatorId.nullable(),
    request_submission_id: z.string().nullable(),
    request_submission_receipts: z.unknown(),
    defaults_initialized: z.boolean(),
});
export const testInstanceInitializer = z.object({
    id: testInstanceId.optional(),
    brew_batch_id: brewBatchId.optional().nullable(),
    brew_sample_id: brewSampleId.optional().nullable(),
    test_template_id: testTemplateRevisionId.optional().nullable(),
    name: z.string(),
    test_number: z.string().optional().nullable(),
    status: testStatusEnum.optional(),
    is_external: z.boolean().optional(),
    external_test_partner_id: externalTestPartnerId.optional().nullable(),
    assigned_operator_id: operatorId.optional().nullable(),
    reviewed_by_operator_id: operatorId.optional().nullable(),
    planned_start_at: z.date().optional().nullable(),
    actual_start_at: z.date().optional().nullable(),
    planned_completion_at: z.date().optional().nullable(),
    actual_completion_at: z.date().optional().nullable(),
    reviewed_at: z.date().optional().nullable(),
    overall_result: testOverallResultEnum.optional().nullable(),
    result_summary: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    test_session_id: testSessionId.optional().nullable(),
    food_recipe_id: foodRecipeId.optional().nullable(),
    food_project_benchmark_id: foodBenchmarkId.optional().nullable(),
    food_test_round_id: foodTestRoundId.optional().nullable(),
    fermentation_sample_id: fermentationSampleId.optional().nullable(),
    lab_sample_code: z.string().optional().nullable(),
    external_sample_reference: z.string().optional().nullable(),
    external_material_ref: z.string().optional().nullable(),
    creation_source: testInstanceCreationSourceEnum.optional(),
    requested_at: z.date().optional().nullable(),
    requested_by: operatorId.optional().nullable(),
    request_withdrawn_at: z.date().optional().nullable(),
    request_withdrawn_by: operatorId.optional().nullable(),
    request_submission_id: z.string().optional().nullable(),
    request_submission_receipts: z.unknown().optional(),
    defaults_initialized: z.boolean().optional(),
});
export const testInstanceMutator = z.object({
    id: testInstanceId.optional(),
    brew_batch_id: brewBatchId.optional().nullable(),
    brew_sample_id: brewSampleId.optional().nullable(),
    test_template_id: testTemplateRevisionId.optional().nullable(),
    name: z.string().optional(),
    test_number: z.string().optional().nullable(),
    status: testStatusEnum.optional(),
    is_external: z.boolean().optional(),
    external_test_partner_id: externalTestPartnerId.optional().nullable(),
    assigned_operator_id: operatorId.optional().nullable(),
    reviewed_by_operator_id: operatorId.optional().nullable(),
    planned_start_at: z.date().optional().nullable(),
    actual_start_at: z.date().optional().nullable(),
    planned_completion_at: z.date().optional().nullable(),
    actual_completion_at: z.date().optional().nullable(),
    reviewed_at: z.date().optional().nullable(),
    overall_result: testOverallResultEnum.optional().nullable(),
    result_summary: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    test_session_id: testSessionId.optional().nullable(),
    food_recipe_id: foodRecipeId.optional().nullable(),
    food_project_benchmark_id: foodBenchmarkId.optional().nullable(),
    food_test_round_id: foodTestRoundId.optional().nullable(),
    fermentation_sample_id: fermentationSampleId.optional().nullable(),
    lab_sample_code: z.string().optional().nullable(),
    external_sample_reference: z.string().optional().nullable(),
    external_material_ref: z.string().optional().nullable(),
    creation_source: testInstanceCreationSourceEnum.optional(),
    requested_at: z.date().optional().nullable(),
    requested_by: operatorId.optional().nullable(),
    request_withdrawn_at: z.date().optional().nullable(),
    request_withdrawn_by: operatorId.optional().nullable(),
    request_submission_id: z.string().optional().nullable(),
    request_submission_receipts: z.unknown().optional(),
    defaults_initialized: z.boolean().optional(),
});
//# sourceMappingURL=TestInstance.js.map